// extracted by mini-css-extract-plugin
module.exports = {"container":"_2OYM1iiTud9ASXEC32GYtg","tableOfContents":"ZA2PFhtcMbVEtDOfPd0Pw","name":"tVEiGK3r9W3Sq8VOxTFZv"};